import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"
import * as styles from "./Profile.module.scss"

const Profile = () => {
  const data = useStaticQuery(graphql`
    query {
      imageProfile: file(relativePath: { eq: "profile_main.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)
  const imageProfile = data.imageProfile.childImageSharp.fluid

  return (
    <div className={styles.root}>
      <div className="container-wide">
        <div className={styles.profile}>
          <Img className={styles.profile__image} fluid={imageProfile} alt="" />
          <div className={styles.profile__text}>
            <h3>Fumiro Sato</h3>
            <p>Fumiro Sato is a director, VFX artist, and colorist.</p>
            <p>
              In recent years, two films he colored were nominated for an Oscar:
              the Best Documentary "Black Box Diaries" and "Instruments of a
              beating heart." His work has been recognized at major film
              festivals, including "Lost Land" (Venice Film Festival), "Very
              Gentle Work," (Cannes Film Festival), and "Ryuichi Sakamoto: async
              Live at the Park Avenue Armory" (Berlin Film Festival).
            </p>
            <p>
              He has also been nominated for the Best VFX for an Asian Film
              Award, often referred to as the Asian version of the Oscar.
            </p>
            <p>
              Fumiro began his career as a 3D modeler for a Japanese animated
              television series. He subsequently worked in the Autodesk Inferno
              department at the post-production house McRay/Tokyo. Later, at the
              Tokyo-based creative agency UltraSuperNew, he planned and directed
              TV commercials. Fumiro is currently based in New York City.
            </p>
            <p>
              He spends his weekends experimenting with 3D sculpting and web
              development projects.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile
